module.exports = __webpack_public_path__ + "static/media/PostgreSQL.e3b079aa.jpg";